var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      style: {
        height: _vm.displayMode ? "100%" : "auto",
        width: "100%",
        marginTop: _vm.displayMode ? "0px" : "80px",
      },
    },
    [
      _vm.displayMode
        ? _c("div", { staticClass: "container-resumo" }, [
            _c("div", { staticClass: "container-btn" }, [
              _c(
                "button",
                {
                  staticClass: "btn-reservar",
                  style: { "background-color": _vm.primaryColor },
                  on: { click: _vm.iniciarReserva },
                },
                [_vm._v("\n        Ver ingressos\n      ")]
              ),
            ]),
          ])
        : _vm.price
        ? _c("div", { staticClass: "container-estado" }, [
            _c("div", { staticClass: "container-total-compra" }, [
              _c("div", [
                _c("strong", { key: _vm.currentTotal }, [
                  _vm._v(
                    "\n          Subtotal: " +
                      _vm._s(_vm.formatMoney(_vm.currentTotal)) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _vm.$props.discountByPaymentMethod &&
                _vm.currentTotalDesconto < _vm.currentTotal
                  ? _c("span", { staticClass: "text-success" }, [
                      _vm._v(
                        "Pagando no " +
                          _vm._s(_vm.discountPaymentMethodsLabel || "Pix") +
                          ": " +
                          _vm._s(_vm.formatMoney(_vm.currentTotalDesconto))
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "container-estado-interno" }, [
              _c(
                "button",
                {
                  staticClass: "btn-controll",
                  style: {
                    "background-color": "white",
                    border: "1px solid " + _vm.primaryColor,
                    color: "black",
                  },
                  attrs: { disabled: _vm.submitting },
                  on: { click: _vm.voltar },
                },
                [
                  !_vm.submitting
                    ? _c("i", { staticClass: "fa-solid fa-angle-left" })
                    : _vm._e(),
                  _vm._v("  \n        Voltar\n      "),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-controll",
                  style: { "background-color": _vm.primaryColor },
                  attrs: { disabled: !_vm.canAdvance || _vm.submitting },
                  on: { click: _vm.avancar },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.submitting ? "Aguarde..." : "Avançar") +
                      "  \n        "
                  ),
                  !_vm.submitting
                    ? _c("i", { staticClass: "fa-solid fa-angle-right" })
                    : _vm._e(),
                ]
              ),
            ]),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }